// Mirror della validazione server-side in oniri-viewer-api/src/utils/ids.ts
// (`isValidResourceId(id, 'mdl')` → 'mdl_' + 16 hex chars).
// Drift risk: se backend estende lo schema (es. mdl_<32hex>), client rejecta
// id validi → bug. Smoke test 4.N validera' un id reale dallo staging.
export const MODEL_ID_REGEX = /^mdl_[a-f0-9]{16}$/;

// Cap difensivo per `?cam=` raw (validation reale del payload base64url +
// decode in 4.L Share feature). Charset base64url: A-Z a-z 0-9 - _.
export const CAMERA_ENCODED_MAX_LENGTH = 256;
const CAMERA_ENCODED_CHARSET = /^[A-Za-z0-9_-]+$/;

export function isValidCameraEncoded(value: string): boolean {
  return (
    value.length > 0 &&
    value.length <= CAMERA_ENCODED_MAX_LENGTH &&
    CAMERA_ENCODED_CHARSET.test(value)
  );
}

// Punto 2 SOG full SH 2026-06-08 (Codex iter1 HIGH #1 fix): variant override
// + viewbox index parsed dall'URL per test-only / debugging deterministic.
// `?variant=rad|sd|hd|source` → orchestrator passa il valore a
// selectVariantForDevice come override (NON auto-select dal manifest).
// `?vb=<int>` → orchestrator attiva quel viewbox post-load (WS5 first-person).
export type VariantUrlOverride = 'rad' | 'sd' | 'hd' | 'source';

export type ParsedShareUrl =
  | {
      kind: 'main';
      modelId: string;
      cameraEncoded: string | null;
      variantOverride: VariantUrlOverride | null;
      viewboxIndex: number | null;
    }
  | {
      kind: 'embed';
      modelId: string;
      cameraEncoded: string | null;
      variantOverride: VariantUrlOverride | null;
      viewboxIndex: number | null;
    }
  | { kind: 'upload-fallback' }
  | { kind: 'invalid'; reason: 'no-id' | 'malformed-id' | 'unknown-route' };

// Whitelist strict per parser: NON accettare altri values per security/contract.
export const VARIANT_OVERRIDE_VALID = ['rad', 'sd', 'hd', 'source'] as const;

// Cap difensivo per ?vb=<int>: 0..255 copre N viewbox scene realistiche
// (Roma 4vb=4, 09_Main Menu=21, futuri scene HEAVY < 30 viewbox per design).
export const VIEWBOX_INDEX_MAX = 255;
